<template>
    <div class="step-first">
        <div  v-if="$route.query.projectStatus === '1'" style="display: flex; justify-content: center; padding-bottom: 40px">
            <Row type="flex">
                <div class="boxs-div boxs-left">
                    选择计划：
                    <Select v-model="selectProject" style="width:202px;" @change="changeSelect(item)">
                        <Option v-for="item in projectList" :key="item.projectId" :value="item.projectId">{{ item.projectId }}</Option>
                    </Select>
                </div>
            </Row>
        </div>
        <div v-else>
        <Row type="flex">
            <div class="boxs-div boxs-left">
                结算渠道：
                <Select v-model="settleChannel" style="width:140px;">
                    <Option v-for="item in settleChannelList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <div class="boxs-div boxs-left">
                <span class="input-label">选择采购部门：</span>
                <span class="Cascader">
                    <Cascader :data="departmentData"
                        v-model="department"
                        @on-change="changeDepartment"
                        style="width:300px;"
                    ></Cascader>
                </span>
            </div>
            <div class="boxs-div boxs-left" v-if="projectStatus !== '1' && quotationStatus === '1'" style="display: flex;align-items: center;">
                <span class="input-label" style="min-width: 75px">选择询价单：</span>
                <Select v-model="selectQuotation" filterable clearable style="width: 300px">
                    <Option v-for="(item, index) in quotationList"
                        :key="index"
                        :value="item.quotationNo"
                        :label="item.quotationNo"
                    >
                        <span>{{ item.quotationNo }}</span>
                        <span style="float:right;">{{item.name}}</span>
                    </Option>
                </Select>
            </div>
        </Row>
        <div class="table-title">
            <Row type="flex">
                <div class="boxs-div">
                    <span class="input-label">选择物资分类：</span>
                    <span class="Cascader">
                        <Cascader
                            :data="productClassifyData"
                            v-model="productClassify"
                            @on-change="productClassifyChange"></Cascader>
                    </span>
                </div>
                <div class="boxs-div">
                    <span class="input-label">输入物资名称：</span>
                    <span class="Cascader">
                        <Input placeholder="物资名称"
                            v-model="productName"/>
                    </span>
                    <Button
                        type="primary"
                        @click="[productByClassifyVar.productName = productName,
                            productByClassifyVar.pageNumber = 1,
                            getProductByClassifyNo]">
                        搜索
                    </Button>
                </div>
            </Row>
        </div>
        <Row type="flex" justify="space-between" class="table-padding-0">
            <Col :span="12">
                <div class="boxs-div">
                    <Button type="primary" @click="addMultipleTerm">批量添加</Button>
                </div>
                <Table
                    :columns="columns"
                    :data="leftData"
                    :height="520"
                    @on-selection-change="getLeftSelectionChange"
                    ref="leftData">
                    <template slot-scope="{ row }" slot="action">
                        <Button size="small" @click="addRightData(row)" v-if="!row._disabled">添加</Button>
                        <Button size="small" v-else>已添加</Button>
                    </template>
                </Table>
                <div class="pages-footer">
                    <Page
                        :current="productByClassifyVar.pageNumber"
                        :total="leftTotal"
                        show-sizer
                        :page-size="productByClassifyVar.pageSize"
                        @on-page-size-change="getLeftChangePageSize"
                        @on-change="getLeftChangePageNum"/>
                </div>
            </Col>
            <Col class="rable-separate-img">
                <img src="../../assets/images/transfer_icon.png" class="absolute-center">
            </Col>
            <Col :span="10">
                <div class="table-title table-title-r">
                    <Button type="primary" @click="removeMultipleTerm">批量删除</Button>
                </div>
                <Table
                    :columns="columns"
                    :data="rightSectionData"
                    :height="520"
                    :loading="loading"
                    @on-selection-change="getRightSelectionChange">
                    <template slot-scope="{ row }" slot="action">
                        <Button @click="removeRightItems(row)" size="small">移除</Button>
                    </template>
                </Table>
                <!-- <div class="pages-footer">
                    <Page
                        :current="rightPages.pageNumber"
                        :total="rightData.length || 1"
                        show-sizer
                        :page-size="rightPages.pageSize"
                        @on-page-size-change="getRightChangePageSize"
                        @on-change="getRightChangePageNum"/>
                </div> -->
            </Col>
        </Row>
        </div>
        <div class="next-step">
            <Button class="prev-step" @click="goBackPrev">返回</Button>
            <Button type="primary" @click="getNextStep">下一步</Button>
        </div>
    </div>
</template>

<script>
import { queryProductClassify, queryProductByClassifyNo, getOriginalByOriginNo, getAllSettleChannel, getMyProjects, selectQuotationInfoList } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
import { creatMultidimensionalArray } from '@/assets/js/creatArr.js';
import { clone } from '@/assets/js/clone.js';
export default {
    data() {
        return {
            // 部门选择
            department: [],
            departmentData: [],

            // 物资分类
            productClassify: [],
            productClassifyData: [],

            // 物资名称
            productName: '',

            // 穿梭框
            columns: [
                {
                    type: 'selection',
                    width: 50,
                    align: 'center'
                },
                {
                    title: '物资名称',
                    key: 'productname',
                    minWidth: 100
                },
                {
                    title: '物资规格',
                    key: 'productspectype',
                    minWidth: 100
                },
                {
                    title: '单位',
                    key: 'productspec',
                    minWidth: 80
                },
                {
                    title: '物资分类',
                    key: 'classifyname',
                    minWidth: 100
                },
                {
                    title: '物资编码',
                    key: 'productno',
                    minWidth: 90
                },
                {
                    title: 'SPU码',
                    key: 'productspu',
                    minWidth: 100
                },
                {
                    title: '操作',
                    fixed: 'right',
                    slot: 'action',
                    align: 'center',
                    minWidth: 80
                }
            ],
            leftData: [],
            leftTotal: 10,

            rightData: [],
            rightSectionData: [],
            rightPages: {
                pageNumber: 1,
                pageSize: 10
            },

            // 表格多选 选中项
            leftSelectOptions: [],
            rightSelectOptions: [],

            // 物资列表查询参数
            productByClassifyVar: {
                pageNumber: 1,
                pageSize: 10,
                classifyNo: '',
                cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                productName: '' // 物资名称
            },

            timeOuts: null,
            settleChannelList: [],
            settleChannel: '',
            selectProject: '',
            projectList: [],
            projectInfo: {},
            projectId: '',
            quotationList: [],
            selectQuotation: '',
            quotationStatus: '',
            projectStatus: '',
            loading: false
        };
    },

    watch: {
        rightData: {
            handler() {
                this.getAllTableChange();
                this.setRightTablePages();
            },
            deep: true
        },

        rightPages: {
            handler() {
                this.setRightTablePages();
            },
            deep: true
        },

        leftData: {
            handler() {
                this.getAllTableChange();
            },
            deep: true
        },

        productByClassifyVar: {
            handler() {
                this.getProductByClassifyNo();
            },
            deep: true
        },

        productClassify(val) {
            this.productByClassifyVar.pageNumber = 1;
        },

        productName(val) {
            if (val) {
                this.productClassify = [];
                this.productByClassifyVar.classifyNo = '';
            }
        }
    },
    created() {
        if (this.$route.query.projectStatus !== '1') {
            this.getSettleChannel();
            this.getAllOrganList();
        }
    },
    mounted() {
        this.$store.commit('setStep', 0);
        const supplierFun = JSON.parse(window.localStorage.getItem('supplierFunction'));
        this.quotationStatus = supplierFun.quotation > -1 ? '1' : '0';
        this.projectStatus = supplierFun.project1 > -1 ? '1' : '0';
        if (this.$route.query.projectStatus !== '1') {
            const dataVar = JSON.parse(decodeURI(window.sessionStorage.getItem('StepFirst')));
            this.getProductClassify();
            this.getSessionItem();
            setTimeout(() => {
                if (this.$route.query.originNo && !dataVar) {
                    this.rightData = [];
                    this.getOriginalByOriginNo();
                }
            }, 1000);
        } else {
            this.getMyProjects();
            const dataVar = JSON.parse(decodeURI(window.sessionStorage.getItem('StepFirst')));
            if (dataVar) {
                this.selectProject = dataVar.projectId;
            }
        }
    },

    methods: {
        // 判断是否存在 session 数据
        getSessionItem() {
            this.productByClassifyVar.projectId = this.$route.query.projectId;
            const dataVar = JSON.parse(decodeURI(window.sessionStorage.getItem('StepFirst')));
            if (dataVar) {
                this.department = dataVar.department;
                if (this.projectStatus !== '1' && this.quotationStatus === '1') {
                    this.getQuotation(this.department[this.department.length - 1]);
                }
                this.selectQuotation = dataVar.selectQuotation;
                this.settleChannel = dataVar.settleChannel;
                this.productByClassifyVar = dataVar.leftDataVar;
                const result = dataVar.rightData;
                result.forEach(item => {
                    item.productname = item.productName || item.productname;
                    item.productspu = item.spu;
                    item.productno = item.productNo || item.productno;
                    item.productspectype = item.productSpectype || item.productspectype;
                    item.classifyname = item.classifyname;
                });
                this.rightData = result;
                this.productName = dataVar.leftDataVar.productName;
                this.getProductByClassifyNo();
            } else {
                this.getProductByClassifyNo();
            }
        },
        changeSelect(item) {
            this.projectInfo = item;
        },
        // 获取计划
        getMyProjects() {
            this.$apollo.query({
                query: getMyProjects,
                context: { useApi1: false },
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                    supplierNo: Cookies.getJSON('USER-INFO').supplierNo
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.getMyProjects;
                this.projectList = result.data;
            });
        },
        changeDepartment(data) {
            if (data.length && this.projectStatus !== '1' && this.quotationStatus === '1') {
                this.getQuotation(data[data.length - 1]);
                this.selectQuotation = '';
            }
        },
        // 获取询价单
        getQuotation(v) {
            this.$apollo.query({
                query: selectQuotationInfoList,
                context: { useApi1: false },
                variables: {
                    condi: {
                        name: '',
                        supplierNo: Cookies.getJSON('USER-INFO').supplierNo,
                        state: 1,
                        organ: v
                    },
                    cliqueNo: Cookies.getJSON('cliqueNo').toString()
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.selectQuotationInfoList;
                if (data && data.code === 200) {
                    if (!data.data.length) {
                        this.$setNotice('暂无询价单');
                    } else {
                        this.quotationList = data.data;
                    }
                } else {
                    this.$setNotice(data.message);
                }
            });
        },
        // 获取详情数据
        getOriginalByOriginNo() {
            this.loading = true;
            this.$apollo.query({
                query: getOriginalByOriginNo,
                variables: {
                    cliqueNo: `${Cookies.getJSON('cliqueNo')}`,
                    originNo: this.$route.query.originNo
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.getOriginalByOriginNo;
                this.loading = false;
                if (data && data.code === 200) {
                    this.department = data.data.organNoPath;
                    this.selectQuotation = data.data.quotationNo;
                    this.settleChannelList.forEach(item => {
                        if (item.label === data.data.settleChannel) {
                            this.settleChannel = item.value;
                        }
                    });
                    if (this.projectStatus !== '1' && this.quotationStatus === '1') {
                        this.getQuotation(data.data.organNo);
                    }
                    sessionStorage.setItem('projectIsModify', JSON.stringify(data.data.items));
                    const result = clone(data.data.items);
                    result.forEach(item => {
                        if (item.productName) {
                            item.productname = item.productName;
                            item.productno = item.productNo;
                            item.productspu = item.spu;
                            item.productspectype = item.productSpectype;
                            item.productspec = item.productUnit;
                            item.classifyname = item.classifyName;
                            item.unitPrice = item.unitPrice;
                            if (item.type === 2) {
                                item.disabled = Number(item.unitPrice);
                            } else {
                                item.disabled = item.price2 ? Number(item.price2) : Number(item.price1);
                            }
                            if (this.$route.query.projectId) {
                                if (item.supplyCount !== null) {
                                    if (this.$route.query.modify) {
                                        if (Number(item.supplyCount) > 0) {
                                            item.productCount = Number(item.productCount).toFixed(3);
                                            item.supplyCount = Number(item.supplyCount).toFixed(3);
                                        } else {
                                            item.productCount = item.productCount;
                                            item.supplyCount = item.productCount;
                                        }
                                    } else {
                                        item.productCount = Number(item.supplyCount).toFixed(3);
                                        item.supplyCount = Number(item.supplyCount).toFixed(3);
                                    }
                                } else {
                                    item.productCount = item.productCount;
                                    item.supplyCount = item.productCount;
                                }
                            }
                        }
                    });
                    this.rightData = result;
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        // 获取部门的联级列表
        async getAllOrganList() {
            this.departmentData = this.$store.state.organs;
            if (this.departmentData.length) {
                clearTimeout(this.timeOuts);
            } else {
                this.timeOuts = setTimeout(() => {
                    this.getAllOrganList();
                }, 1000);
            }
        },
        // 结算渠道
        getSettleChannel() {
            this.$apollo.query({
                query: getAllSettleChannel,
                variables: {
                    cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                    all: 0
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const result = res.data.getAllSettleChannel;
                result.data.forEach(item => {
                    item.label = item.name;
                    item.value = item.alias;
                });
                this.settleChannelList = result.data;
            });
        },
        // 获取物资分类的联级列表
        getProductClassify() {
            this.$apollo.query({
                query: queryProductClassify,
                variables: {
                    cliqueNo: `${Cookies.getJSON('cliqueNo')}`,
                    supplierNo: `${Cookies.getJSON('USER-INFO').supplierNo}`
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductClassify;
                if (data && data.data && data.code === 200) {
                    let parentData = [];
                    for (let i = 5;i > 0;i -= 1) {
                        if (data.data[i.toString()].length) {
                            parentData = creatMultidimensionalArray(
                                data.data[i.toString()],
                                parentData,
                                'classifyParentNo',
                                'classifyName',
                                'classifyNo'
                            );
                        } else {
                            continue;
                        }
                    }
                    parentData.forEach(ele => {
                        let classifyName, classifyNo, children, value, label;
                        ({ classifyName: label, classifyNo: value, children } = ele);
                        this.productClassifyData.push({
                            value,
                            label,
                            children
                        });
                    });
                } else {
                    this.$setNotice('分类列表获取失败，刷新试试吧');
                }
            });
        },

        // 获取物资列表
        getProductByClassifyNo() {
            this.$apollo.query({
                query: queryProductByClassifyNo,
                variables: this.productByClassifyVar,
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.queryProductByClassifyNo;
                if (data && data.data && data.code === 200) {
                    this.$Notice.destroy();
                    // this.$setNotice('物资列表获取成功');
                    data.data.forEach(ele => {
                        ele._disabled = false;
                    });
                    this.leftTotal = data.count;
                    this.leftData = data.data;
                } else {
                    this.$setNotice('物资列表获取失败，刷新试试吧');
                }
            });
        },

        // 选中物资分类
        productClassifyChange(val) {
            this.productName = '';
            this.productByClassifyVar.productName = '';
            this.productByClassifyVar.classifyNo = val[val.length - 1] || '';
        },

        // 封装 遍历

        // 封装左右表格变化
        getAllTableChange() {
            this.leftData.forEach(ele => {
                let leftIndex = this.rightData.findIndex(item => {
                    return item.productno === ele.productno;
                });
                if (leftIndex !== -1) {
                    ele._disabled = true;
                } else {
                    ele._disabled = false;
                }
            });
            if (this.rightData.length) {
                this.rightPages.pageNumber = Math.ceil(this.rightData.length / this.rightPages.pageSize);
            }
        },

        // 右侧 分页操作
        setRightTablePages() {
            // let start = (this.rightPages.pageNumber - 1) * this.rightPages.pageSize;
            // let end = this.rightPages.pageNumber * this.rightPages.pageSize;
            // this.rightSectionData = this.rightData.slice(start, end);
            this.rightSectionData = this.rightData;
        },

        // 左侧表格操作  向右边表格 添加单个 数据
        addRightData(rows) {
            if (this.leftSelectOptions.length) {
                this.$refs.leftData.selectAll(false);
            }
            let addItem = Object.assign({}, this.leftData[rows._index]);
            this.leftData[rows._index]._disabled = true;
            this.rightData.push(addItem);
        },

        // 左侧表格表格多选变化
        getLeftSelectionChange(selects) {
            this.leftSelectOptions = selects;
        },

        // 向右边表格 批量添加多个 数据
        addMultipleTerm() {
            if (this.leftSelectOptions.length) {
                this.rightData = this.rightData.concat(this.leftSelectOptions);

                // 取消全选
                this.$refs.leftData.selectAll(false);
            } else {
                this.$setNotice('没有要添加的物资');
            }
        },

        // pageNumber 变化
        getLeftChangePageNum(val) {
            this.productByClassifyVar.pageNumber = val;
        },

        // pagesize 变化
        getLeftChangePageSize(size) {
            this.productByClassifyVar.pageSize = size;
        },

        // 右侧表格操作 单个移除数据
        removeRightItems(rows) {
            this.rightData.splice(rows._index, 1);
        },

        // 右侧表格表格多选变化
        getRightSelectionChange(selects) {
            this.rightSelectOptions = selects;
        },

        // 右侧表格删除多个数据
        removeMultipleTerm() {
            if (this.rightSelectOptions.length) {
                this.rightSelectOptions.forEach(ele => {
                    let rightIndex = this.rightData.findIndex(term => term.productno === ele.productno);
                    this.rightData.splice(rightIndex, 1);
                });
            } else {
                this.$setNotice('没有要删除的物资');
            }
        },

        // pagesize 变化
        getRightChangePageSize(val) {
            this.rightPages.pageSize = val;
        },

        // pageNumber 变化
        getRightChangePageNum(val) {
            this.rightPages.pageNumber = val;
        },

        /**
         * 1： sessionStorage存储物资列表参数项、已选取物资、物资类别， 当前部门
         * 2： 跳转第二步
         */
        goBackPrev() {
            this.$router.go(-1);
        },
        getNextStep() {
            if (this.$route.query.projectStatus !== '1') {
                if (!this.rightData.length) {
                    this.$setNotice('还没有选取物资');
                    return;
                } else if (!this.settleChannel) {
                    this.$setNotice('请选择结算渠道');
                    return;
                } else if (!this.department.length) {
                    this.$setNotice('请选择采购部门');
                    return;
                }
                if (this.projectStatus !== '1' && this.quotationStatus === '1') {
                    if (!this.selectQuotation) {
                        this.$setNotice('请选择询价单');
                        return;
                    }
                }
                this.rightData.forEach(right => {
                    if (!right.productCount) {
                        right.productCount = '';
                    }
                    if (!right.unitPrice) {
                        right.unitPrice = '';
                    }
                    if (!right.totalPrice) {
                        right.totalPrice = '';
                    }
                    if (!right.type) {
                        right.type = 1;
                    }
                });
                let obj = {
                    productClassify: this.productClassify,
                    settleChannel: this.settleChannel,
                    department: this.department,
                    selectQuotation: this.selectQuotation,
                    rightData: this.rightData,
                    leftDataVar: this.productByClassifyVar
                };
                let datas = encodeURI(JSON.stringify(obj));
                window.sessionStorage.setItem('StepFirst', datas);
                this.$store.commit('setStep', 1);
                if (this.$route.query.originNo && !this.$route.query.draft) {
                    this.$router.push({
                        path: '/index/manualBuild/stepSecond',
                        query: {
                            originNo: this.$route.query.originNo,
                            projectId: this.$route.query.projectId,
                            modify: this.$route.query.modify,
                            isLocked: this.$route.query.isLocked,
                            quotation: this.selectQuotation
                        }
                    });
                } else if (this.$route.query.originNo && this.$route.query.draft) {
                    this.$router.push({
                        path: '/index/manualBuild/stepSecond',
                        query: {
                            originNo: this.$route.query.originNo,
                            projectId: this.$route.query.projectId,
                            draft: this.$route.query.draft,
                            quotation: this.selectQuotation
                        }
                    });
                } else if (this.$route.query.quotation) {
                    this.$router.push({
                        path: '/index/manualBuild/stepSecond',
                        query: {
                            quotation: this.selectQuotation
                        }
                    });
                } else {
                    this.$router.push({
                        path: '/index/manualBuild/stepSecond'
                    });
                }
            } else {
                if (!this.selectProject) {
                    this.$setNotice('还没有选取计划');
                    return;
                }
                let obj = {
                    projectId: this.selectProject
                };
                let datas = encodeURI(JSON.stringify(obj));
                window.sessionStorage.setItem('StepFirst', datas);
                this.$store.commit('setStep', 1);
                this.$router.push({
                    path: '/index/manualBuild/stepSecond',
                    query: {
                        projectId: this.selectProject,
                        type: this.$route.query.type,
                        isLocked: this.projectInfo.isLocked ? '1' : '2'
                    }
                });
            }
        }
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ManualBuildReceipt/StepFirst.vue